<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Sticker } from "@/model/StickerType";
import { stickerSvgIcon } from "@/model/StickerType";
import { stickerColors } from "@/model/colors";

import { stickerName } from "./baseSticker";

defineProps<{ sticker: Sticker }>();
</script>

<template>
  <span
    class="sticker-icon"
    :style="{ color: stickerColors[sticker.color] }"
    role="img"
    :aria-label="stickerName(sticker)"
  >
    <SvgIcon :name="stickerSvgIcon[sticker.icon]" />
  </span>
</template>

<style lang="scss" scoped>
.sticker-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0.4em;

  // SvgIcon's root <svg> fills the wrapper.
  > svg {
    height: 100%;
    width: 100%;
  }
}
</style>
